import styled from 'styled-components';
import { CalciteButton, CalciteIcon } from 'components/Calcite';

export const StyledMetricsContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const StyledTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 600px;
  margin: auto;
`;

export const StyledButton = styled(CalciteButton)`
  margin: 1rem;
`;

export const StyledPlusIcon = styled(CalciteIcon).attrs({
  icon: 'plus',
  scale: 'l'
})`
  scale: 5;
  color: ${({ theme }) => theme.color.info};
  margin: 3rem;
`;

export const StyledCheckIcon = styled(CalciteIcon).attrs({
  icon: 'check',
  scale: 'l'
})`
  scale: 5;
  color: ${({ theme }) => theme.color.success};
  margin: 3rem;
`;
